<div class="border-container bg-white  mb-3">
  <div class="header border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2 title">{{ 'Sellers.Products.ContractDeliveryAddress' | translate }}</h3>
    </div>
  </div>
  <form *ngIf="deliveryAddressForm" class="row" [formGroup]="deliveryAddressForm">
    <div class="row">
      <div class="col-6">
        <div class="d-flex flex-row justify-content-between mb-3">
          <div>
            <label>
              {{ 'Sellers.Products.Governorate' | translate }}
              <span class="text-danger">*</span>
            </label>
            <select class="form-control form-select"
              [formControl]="convertDeliveryAddressFormControls('contractDeliveryGovernate')">
              <option value="null" disabled selected>{{ 'Sellers.Products.SelectGovernorate' | translate }}</option>
              <option *ngFor="let city of cities" [value]="city.city">{{ city.city }}</option>
            </select>
          </div>
          <div>
            <label>
              {{ 'Sellers.Products.Area' | translate }}
              <span class="text-danger">*</span>
            </label>
            <input type="text" placeholder="{{ 'Sellers.Products.Area' | translate }}"
              [formControl]="convertDeliveryAddressFormControls('contractDeliveryArea')" class="form-control">
            <small class="text-danger" *ngIf="fvDeliveryAddress.formErrors.contractDeliveryArea">
              {{ fvDeliveryAddress.formErrors.contractDeliveryArea }}
            </small>
          </div>
        </div>

        <div class="mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.ContractDeliveryDuration' | translate }} <span
                class="text-danger">*</span></label>
            <select class="form-control form-select"
              [formControl]="convertDeliveryAddressFormControls('contractDeliveryDuration')">
              <option value="3">3</option>
              <option value="5">5</option>
            </select>
          </div>

        </div>
      </div>
      <div class="col-6">
        <div class="form-group">

          <label>
            {{ 'Sellers.Products.Address' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input type="text" placeholder="{{ 'Sellers.Products.Address' | translate }}"
            [formControl]="convertDeliveryAddressFormControls('contractDeliveryAddress')" class="form-control">
          <small class="text-danger" *ngIf="fvDeliveryAddress.formErrors.contractDeliveryAddress">
            {{ fvDeliveryAddress.formErrors.contractDeliveryAddress }}
          </small>


        </div>
      </div>

    </div>
    <button
      type="submit"
      class="btn btn-primary my-3 col-12 col-sm-4  "
      (click)="onConfirmContract()"
      [disabled]="disable()"
    >
      {{ 'Sellers.Dashboard.ConfirmContract' | translate }}
    </button>
  </form>
</div>
